export const uiConfig = {
    DEBUG: {
        // Game resizing for debugging/responsiveness testing
        ENABLE_EASY_RESIZABLE_GAME_CONTAINER: false,
        DEFAULT_GAME_VIEWPORT_WIDTH_IN_RESIZABLE_MODE: 1920,
        DEFAULT_GAME_VIEWPORT_HEIGHT_IN_RESIZABLE_MODE: 1080
    }
};
